import React, { useEffect } from "react";
import { getSnUserIdFromToken } from "utils/authUtils";
import { PROCURE_TO_PAY_INCIDENT_ROWS_PER_PAGE } from "../../../constants/generalConstants";
import PropTypes from "prop-types";
import PaginatedTable from "../../tables/paginatedTable";
import { servicenowUrl } from "../../../services/apiUtils/config/urls";
import TileAccordion from "../tileAccordion";
import ProcurementIncidentsRow from "./procurementIncidentsRow";
import useServiceNowProcurementInvoiceCases from "../../../services/apiUtils/hooks/useServiceNowProcurementInvoiceCases";
import useServiceNowUser from "services/apiUtils/hooks/useServiceNowUser";
import { serviceNames, SERVICENOW } from "constants/serviceNames";

const ProcurementInvoiceCasesSection = ({
    isEditing,
    maintenanceMode,
    viewClosed = false,
}) => {
    const {
        procurementInvoiceCaseList,
        setPagesToLoad,
        loadedPageCount,
        procurementInvoiceCaseCount,
        errorMessage,
    } = useServiceNowProcurementInvoiceCases(viewClosed);

    const { serviceNowUser, serviceNowUserIsLoading } = useServiceNowUser();

    const preloadNextPage = (newPage) => {
        if (
            newPage + 1 >= loadedPageCount &&
            procurementInvoiceCaseCount >
                (newPage + 1) * PROCURE_TO_PAY_INCIDENT_ROWS_PER_PAGE
        ) {
            void setPagesToLoad(newPage + 2);
        }
    };

    useEffect(() => {
        if (
            loadedPageCount === 1 &&
            procurementInvoiceCaseCount > PROCURE_TO_PAY_INCIDENT_ROWS_PER_PAGE
        ) {
            void setPagesToLoad(2);
        }
    }, [loadedPageCount, procurementInvoiceCaseCount, setPagesToLoad]);

    const snProcurementInvoiceCasesUrl = () => {
        if (serviceNowUser && !serviceNowUserIsLoading) {
            const snUserId = getSnUserIdFromToken(serviceNowUser);
            if (snUserId) {
                const query = encodeURIComponent(`requested_by=${snUserId}`);
                return `${servicenowUrl}/sn_ap_cm_ap_case_list.do?sysparm_query=${query}`;
            }
        }
        return `${servicenowUrl}/sn_ap_cm_ap_case_list.do`;
    };

    return (
        <TileAccordion
            serviceName="Procurement Invoice Cases"
            tileName="incidents"
            maintenanceMode={maintenanceMode}
            errorMessage={errorMessage}
            count={procurementInvoiceCaseCount}
            isEditing={isEditing}
        >
            <PaginatedTable
                totalItems={procurementInvoiceCaseCount}
                isEditing={isEditing}
                serviceUrl={snProcurementInvoiceCasesUrl()}
                itemsPerPage={PROCURE_TO_PAY_INCIDENT_ROWS_PER_PAGE}
                service={`${serviceNames[SERVICENOW]}-Procurement`}
                items={procurementInvoiceCaseList ?? []}
                Row={ProcurementIncidentsRow}
                onPageChange={preloadNextPage}
            />
        </TileAccordion>
    );
};

ProcurementInvoiceCasesSection.propTypes = {
    isEditing: PropTypes.bool.isRequired,
    maintenanceMode: PropTypes.bool,
    viewClosed: PropTypes.bool,
};

export default ProcurementInvoiceCasesSection;
